/**
 * Configuracoes dos wizards modulares.
 * Cada wizard define uma sequencia de steps reutilizaveis.
 *
 * Propriedades de cada step:
 * - component: Nome do componente step (corresponde a um arquivo em wizard/steps/)
 * - mode: Modo de operacao do step (create-only, select-only, select-or-create)
 * - label: Label exibido no Stepper
 * - optional: Se o step pode ser pulado
 * - props: Props extras passados ao componente (entityType, min, max, etc.)
 *
 * A ordem dos 3 EntityPickerSteps determina a experiencia do usuario:
 * - O primeiro step e o "trigger" (a entidade que o usuario quer criar)
 * - Os demais se adaptam ao contexto ja construido nos steps anteriores
 *
 * PlaceBindingStep e ScheduleStep sao expandidos dinamicamente pelo WizardShell:
 * - PlaceBindingStep: 1 step por local selecionado
 * - ScheduleStep: 1 step por combinacao local x profissional
 */

export const WIZARD_CONFIGS = {
  'setup-completo': {
    id: 'setup-completo',
    name: 'Configurar Meu Negocio',
    description: 'Configure profissionais, servicos, local e agenda de uma vez',
    icon: 'RocketLaunch',
    steps: [
      {
        component: 'EntityPickerStep',
        mode: 'select-or-create',
        label: 'Profissionais',
        props: { entityType: 'professional', min: 1 },
      },
      {
        component: 'EntityPickerStep',
        mode: 'select-or-create',
        label: 'Servicos',
        props: { entityType: 'service', min: 1 },
      },
      {
        component: 'EntityPickerStep',
        mode: 'select-or-create',
        label: 'Locais',
        props: { entityType: 'place', min: 1 },
      },
      {
        component: 'PlaceBindingStep',
        label: 'Vinculos',
      },
      {
        component: 'ScheduleStep',
        label: 'Agenda',
        optional: true,
      },
      {
        component: 'ReviewStep',
        label: 'Resumo',
      },
      {
        component: 'ProcessingStep',
        label: 'Criacao',
      },
    ],
  },

  'add-place': {
    id: 'add-place',
    name: 'Novo Local',
    description: 'Crie um local e configure profissionais e servicos',
    icon: 'LocationOn',
    steps: [
      {
        component: 'EntityPickerStep',
        mode: 'create-only',
        label: 'Locais',
        props: { entityType: 'place', min: 1 },
      },
      {
        component: 'EntityPickerStep',
        mode: 'select-or-create',
        label: 'Profissionais',
        props: { entityType: 'professional', min: 1 },
      },
      {
        component: 'EntityPickerStep',
        mode: 'select-or-create',
        label: 'Servicos',
        props: { entityType: 'service', min: 1 },
      },
      {
        component: 'PlaceBindingStep',
        label: 'Vinculos',
      },
      {
        component: 'ScheduleStep',
        label: 'Agenda',
        optional: true,
      },
      {
        component: 'ReviewStep',
        label: 'Resumo',
      },
      {
        component: 'ProcessingStep',
        label: 'Criacao',
      },
    ],
  },

  'add-professional': {
    id: 'add-professional',
    name: 'Novo Profissional',
    description: 'Cadastre um profissional e vincule a locais e servicos',
    icon: 'PersonAdd',
    steps: [
      {
        component: 'EntityPickerStep',
        mode: 'create-only',
        label: 'Profissionais',
        props: { entityType: 'professional', min: 1 },
      },
      {
        component: 'EntityPickerStep',
        mode: 'select-or-create',
        label: 'Servicos',
        props: { entityType: 'service', min: 1 },
      },
      {
        component: 'EntityPickerStep',
        mode: 'select-or-create',
        label: 'Locais',
        props: { entityType: 'place', min: 1 },
      },
      {
        component: 'PlaceBindingStep',
        label: 'Vinculos',
      },
      {
        component: 'ScheduleStep',
        label: 'Agenda',
        optional: true,
      },
      {
        component: 'ReviewStep',
        label: 'Resumo',
      },
      {
        component: 'ProcessingStep',
        label: 'Criacao',
      },
    ],
  },

  'add-service': {
    id: 'add-service',
    name: 'Novo Servico',
    description: 'Cadastre um servico e vincule a profissionais e locais',
    icon: 'MedicalServices',
    steps: [
      {
        component: 'EntityPickerStep',
        mode: 'create-only',
        label: 'Servicos',
        props: { entityType: 'service', min: 1 },
      },
      {
        component: 'EntityPickerStep',
        mode: 'select-or-create',
        label: 'Profissionais',
        props: { entityType: 'professional', min: 1 },
      },
      {
        component: 'EntityPickerStep',
        mode: 'select-or-create',
        label: 'Locais',
        props: { entityType: 'place', min: 1 },
      },
      {
        component: 'PlaceBindingStep',
        label: 'Vinculos',
      },
      {
        component: 'ScheduleStep',
        label: 'Agenda',
        optional: true,
      },
      {
        component: 'ReviewStep',
        label: 'Resumo',
      },
      {
        component: 'ProcessingStep',
        label: 'Criacao',
      },
    ],
  },

  'add-schedule': {
    id: 'add-schedule',
    name: 'Nova Agenda',
    description: 'Crie uma agenda para um profissional em um local',
    icon: 'CalendarMonth',
    steps: [
      {
        component: 'EntityPickerStep',
        mode: 'select-only',
        label: 'Locais',
        props: { entityType: 'place', min: 1 },
      },
      {
        component: 'EntityPickerStep',
        mode: 'select-only',
        label: 'Profissionais',
        props: { entityType: 'professional', min: 1 },
      },
      {
        component: 'ScheduleStep',
        label: 'Agenda',
      },
      {
        component: 'ReviewStep',
        label: 'Resumo',
      },
      {
        component: 'ProcessingStep',
        label: 'Criacao',
      },
    ],
  },
};

export default WIZARD_CONFIGS;
